import { IStyle } from '@fluentui/react';
import { CommonStyles, IH2OTheme } from '@h2oai/ui-kit';

export interface IJobsStyles {
  root?: IStyle;
  description?: IStyle;
  descriptionText?: IStyle;
  list?: IStyle;
  pivotContainer?: IStyle;
  search?: IStyle;
  toggleButtons?: IStyle;
}

export interface IJobsClassNames {
  root: string;
  description?: string;
  descriptionText?: string;
  list?: string;
  pivotContainer?: string;
  search?: string;
  toggleButtons?: string;
}

export const jobsStylesDefault = (theme: IH2OTheme): Partial<IJobsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: theme.semanticColors?.textSecondary,
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px',
  },
  list: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  pivotContainer: {
    flex: 1,
    minHeight: 0,
  },
  search: { display: 'flex', justifyContent: 'space-between', marginTop: '8px', marginBottom: '8px' },
  toggleButtons: {
    lineHeight: '0px',
    ...CommonStyles.flexCenterVertically,
  },
  descriptionText: { ...CommonStyles.flexCenterVertically },
});
